import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Servicios.css';

const Servicios = () => {
  const haloRef = useRef(null);

  // Lista de servicios
  const services = [
    { id: 1, title: 'Prefabricado de tuberías', image: '/images/fotos/jamalcoPiping/jamalcoPiping_3.jpg' },
    { id: 2, title: 'Montaje de tuberías', image: '/images/fotos/otros/Rever_2.webp' },
    { id: 3, title: 'Prefabricado e instalación de estructura metálica', image: '/images/fotos/estructura/estructura_10.jpeg' },
    { id: 4, title: 'Instalación de Geosintéticos', image: '/images/fotos/otros/Rever_8.webp'},
    { id: 5, title: 'Prefabricado y montaje de tuberías de HDPE / Termofusión', image: '/images/fotos/jamalcoPiping/jamalcoPiping_1.jpg' },
    { id: 6, title: 'Servicios de Topografía GPS - Estación Total - Levantamientos', image: '/images/fotos/topografia/topografia_3.jpeg' },
    // { id: 7, title: 'Construcción de obras civiles', image: '/images/fotos/otros/Rever_construccion.jpg' },
    { id: 8, title: 'Cálculo, diseño y elaboración de planos electromecánicos y civiles', image: '/images/fotos/otros/Rever_calculo.webp' },
  ];

  useEffect(() => {
    // Efecto halo que sigue al mouse
    const handleMouseMove = (e) => {
      if (haloRef.current) {
        haloRef.current.style.left = `${e.clientX}px`;
        haloRef.current.style.top = `${e.clientY}px`;
      }
    };

    document.addEventListener('mousemove', handleMouseMove);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <div className="servicios-container">
      <div className="halo" ref={haloRef}></div>
      
      {/* Hero Section */}
      <section className="servicios-hero">
        <div className="container">
          <h1 className="hero-title">
            Nuestros <span className="highlight">Servicios</span>
          </h1>
          <div className="animated-underline"></div>
          <p className="hero-subtitle">
            Ofrecemos soluciones integrales en la fabricación, montaje e instalación de sistemas industriales y civiles, incluyendo tuberías, estructuras metálicas, geosintéticos, y obras electromecánicas. Contamos con servicios de topografía, cálculos e ingeniería para asegurar la correcta ejecución de proyectos de infraestructura, siempre con un enfoque en <span className="highlight">calidad y eficiencia</span>.
          </p>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider"></div>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              Servicios <span className="highlight">Especializados</span>
            </h2>
            <div className="animated-underline"></div>
            <p className="section-subtitle">
              Cada servicio está respaldado por años de experiencia y tecnología de vanguardia para garantizar resultados excepcionales en cada proyecto que emprendemos.
            </p>
          </div>

          <div className="services-grid">
            {services.map((service) => (
              <div key={service.id} className="service-card">
                <div className="card-front">
                  <div className="image-container">
                    <img src={service.image} alt={service.title} className="service-image" />
                    <div className="image-overlay"></div>
                  </div>
                  <div className="service-info">
                    <div className="service-badge">
                      <span>{service.title}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider"></div>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="container">
          <Link to="/contacto" className="contact-btn">
            Contáctanos
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Servicios;